import { motion } from 'framer-motion';

const variants = {
  hero: {
    className:
      'bg-gradient-to-b from-emerald-50/50 via-white/20 to-transparent',
    height: 'min-h-[60vh]'
  },
  capture: {
    className: 'bg-gradient-to-r from-blue-50/30 via-cyan-50/20 to-transparent',
    height: 'min-h-[50vh]'
  },
  identify: {
    className:
      'bg-gradient-to-l from-emerald-50/30 via-teal-50/20 to-transparent',
    height: 'min-h-0'
  },
  care: {
    className:
      'bg-gradient-to-b from-amber-50/20 via-orange-50/10 to-transparent',
    height: 'min-h-0'
  },
  default: {
    className: 'bg-white',
    height: 'min-h-0'
  }
};

export function SectionBackground({ variant = 'default', children }) {
  const { className, height } = variants[variant] || variants.default;

  return (
    <motion.section
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className={`relative ${className} ${height}`}
    >
      <div className="relative z-10">{children}</div>
    </motion.section>
  );
}
